import SearchMobileRecap from '@ui/Search/MobileRecap/component'
import { isDesktop } from 'assets/core/js/common'
import ElementPropertiesManager from 'assets/core/js/module/element-properties-manager'
import type { SearchMobileRecapType } from '@ui/Search/MobileRecap/component'

export default (): void => {
  const searchMobileRecapEl = document.getElementById('search-mobile-recap')

  searchMobileRecapEl && SearchMobileRecap(searchMobileRecapEl)

  if (searchMobileRecapEl?.hasAttribute('data-variant') && searchMobileRecapEl?.getAttribute('data-variant') !== 'sticky') {
    return
  }

  if (searchMobileRecapEl?.parentElement) {
    const searchMobileRecap = ElementPropertiesManager.getProperty<SearchMobileRecapType>(searchMobileRecapEl, 'searchMobileRecap')
    const parentEl = searchMobileRecapEl.parentElement
    // remove a layout reflow by calculating the height later
    let height: number | null = null

    const handleIntersection: IntersectionObserverCallback = (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !isDesktop()) {
          if (!height) {
            height = parentEl.offsetHeight
          }

          searchMobileRecap?.enableSticky()
          parentEl.style.height = `${height}px`
        }
        if (entry.isIntersecting) {
          searchMobileRecap?.disableSticky()
          parentEl.style.removeProperty('height')
        }
      })
    }

    const observer = new window.IntersectionObserver(handleIntersection, {
      threshold: 0.5,
    })
    observer.observe(parentEl)
  }
}
